import * as types from './mutation-types'
import {BASE_URL} from "@/services/api";

export const loadZones = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/zones/collection', data).then((response) => {
            commit(types.ADD_ZONES, response.data)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadZoneIntervals = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/zone-intervals/collection', data).then((response) => {
            commit(types.ADD_ZONES_INTERVALS, response.data.zoneInterval)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateZone = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('update/' + data.id + '/zone', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const createZone = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/zone', data).then((response) => {
            commit(types.ADD_ZONE, response.data.zone)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteZone = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('delete/' + id + '/zone').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const addIntervals = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/zone-interval/'+ data.id, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const showZoneInterval = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('zone-interval/'+id).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateZoneInterval = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.put('zone-interval/'+ data.id, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteZoneInterval = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('zone-interval/'+id).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const addCountriesWithCities = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/zone-detail', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const showZoneDetail = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/zone-details?zone_id='+id).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteCountriesWithCities = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('delete/zone-detail', {
            params: data
          }).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}